import type { TFunction } from 'i18next';
import { ImageUploadError } from './imageUpload';

export const formatImageUploadError = (error: unknown, t: TFunction): string => {
  if (error instanceof ImageUploadError) {
    return t(`editor.uploadErrors.${error.code}`, {
      label: t(error.labelKey),
      maxKb: error.maxKb,
    });
  }
  return t('editor.uploadErrors.couldNotUploadImage');
};
